import { Utilities } from 'core/domains';

import type { ProductDetail } from 'core/services/bff/@types/product-detail/product-detail';

export const initialState: ProductDetail = {
  data: {
    item: {} as unknown as ProductDetail['data']['item'],
  },
  fetch: {
    message: '',
    status: Utilities.STATUS.IDLE,
  },
};
